<template>
  <div class="modal__wrapper">
    <div class="modal__close">
      <div class="btn" @click="close">
        <Close class="img"/>
      </div>
    </div>
    <div class="modal__header">
      <div class="ttl">
        User Request Matches
      </div>
    </div>
    <div class="modal__body">
      <div class="row">
        <h4 class="label" style="margin-right: 24px">Match by</h4>
        <div class="data">
          <div class="check-item-row">
            <div 
              class="check-item-col" 
              v-for="(field, i) in fieldsMatchingBy"
              :key="i"
            >
              <div class="check-item-wrap">
                <label class="check-item-label">
                  <input
                    type="checkbox"
                    :value="field.value"
                    v-model="form.match_by_field"
                    :true-value="[]"
                    name="match_by_field"
                    class="chec-item"
                    @change="getUserRequestMatches(1)"
                  />
                  {{ field.name }}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box box_selectedAcc">
        <div class="header">
        </div>
        <div class="content">
          <div class="block">
            <div class="hdr">
            </div>
            <Table 
              class="customer-offer-match"
              :key="userRequestMatchesKey" 
              :options="userRequestMatches" 
              @sort="sortBy"
              @applyMatchOffer="applyMatchOffer"
              @change-page="getUserRequestMatches"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Table from './../elem/Table.vue'
import Close from '../img/Close.vue'

export default {
  components: {
    Table,
    Close
  },
  props: {
    options: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {
      userRequestMatchesData: [],
      userRequestMatchesKey: 0,
      userRequestMatches: {
        objName: 'userRequestMatches',
        colsWidth: ['8.5%', '8.5%', '8.5%', '8.5%', '3.2%', '8.5%', '8.5%', '8.5%', '8.5%', '8.5%', '8.5%', '8.5%', '3.3%'],
        header: [
          { ttl: 'Business Type', info: null },
          { ttl: 'License Type', info: null },
          { ttl: 'Country', info: null },
          { ttl: 'Client budget', info: null },
          { ttl: '', info: null },
          { ttl: 'License ID', info: null },
          { ttl: 'Type of license', info: null },
          { ttl: 'Fintech type', info: null },
          { ttl: 'Country', info: null, sort: null },
          { ttl: 'Price', info: null, sort: 'price' },
          { ttl: 'Is verified', info: null, sort: null },
          { ttl: 'Description', info: null },
          { ttl: '', info: null },
        ],
        body: [],
        paginationData: null,
        sort: {
          name: '',
          order: 'asc',
          loading: false
        }
      },
      form: {
        match_by_field: ['fintech_type_id', 'license_type', 'country_id', 'client_budget'],
      },
      fieldsMatchingBy: [
        {
          name: 'Business Type',
          value: 'fintech_type_id'
        },
        {
          name: 'License Type',
          value: 'license_type'
        },
        {
          name: 'Country',
          value: 'country_id'
        },
        {
          name: 'Client Budget',
          value: 'client_budget'
        },
      ],
      clientBudgets: [
        {
          name: '< 100 K',
          value: 100000
        },
        {
          name: '< 250 K',
          value: 250000
        },
        {
          name: '< 500 K',
          value: 500000
        },
        {
          name: '< 1 M',
          value: 1000000
        },
        {
          name: '< 2 M',
          value: 2000000
        },
        {
          name: '< 5 M',
          value: 5000000
        },
        {
          name: '< 10 M',
          value: 10000000
        },
        {
          name: '> 10 M',
          value: 9999999999
        },
      ],
    };
  },
  async created(){
    await this.getUserRequestMatches()
  },
  methods: {
    sortBy (data) {
      console.log(data);
      this.userRequestMatches.sort.loading = true
      this.userRequestMatches.sort.order = this.userRequestMatches.sort.name === data.sort && this.userRequestMatches.sort.order === 'asc'
        ? 'desc' : 'asc'
      this.userRequestMatches.sort.name = data.sort
      
      this.getUserRequestMatches(1)
    },
    async getUserRequestMatches(page = 1) {
      const that = this

      let url = 'admin/user-requests'

      if(this.options.id){
        url += '/get-matches/' + this.options.user.id + '/' + this.options.id
      }
      else if(this.options.user){
        url += '/get-all-matches/' + this.options.user.id
      }

      const sortParams = '&sort=' + this.userRequestMatches.sort.name + '&order=' + this.userRequestMatches.sort.order

      axios.post(url + '?page=' + page + sortParams, this.form).then(function (response) {
        that.userRequestMatches.paginationData = response.data
        that.userRequestMatches.body = []

        response.data.data.forEach(userRequest => {
          let userRequestData = [
            userRequest.fintech_type ? userRequest.fintech_type.name : '',
            userRequest.license_type,
            userRequest.country ? userRequest.country.name : '',
            that.getClientBudget(userRequest.client_budget),
            {type: 'seperator'},
          ];
          
          if(userRequest.matches.length){
            userRequest.matches.forEach(match => {
              that.userRequestMatches.body.push([
                ...userRequestData,
                match.id,
                match.license_type,
                match.fintech_type_id ? match.fintech_type.name : '',
                match.country ? match.country.name : '',
                match.price,
                match.is_verified ? 'Verified' : 'Not verified',
                match.description,
                match.users.length ? '' : {type: 'apply-match-offer', id: match.id}
              ])
            })
          }
          else{
            that.userRequestMatches.body.push([
              ...userRequestData,
              '', '', '', '', '', '', '', 'Licenses Not Found'
            ]);
          }
          
          if (that.userRequestMatches.sort.name) that.userRequestMatches.sort.loading = false
        })
      }).catch((errors) => {
        console.dir(errors)
      })
    },
    async applyMatchOffer(obj){
      await axios.post('admin/business-offers/apply/' + obj.id + '/' + this.options.user.id).then(({ data }) => {
        if(data.applied) {
          this.updateCurrentPage()
          
          this.$store.dispatch('appliedBusinessOffer', {
            
          });
        }
      })
      .catch(errors => {
        console.dir(errors)
      })
    },
    getClientBudget(value){
      for(let i = 0; i < this.clientBudgets.length; i++){
        const el = this.clientBudgets[i];
        
        if(+el.value == +value){
          return el.name
        }
      }
    },
    close() {
      this.$emit("close");
    },
    updateCurrentPage() {
      let currentPage = 1
      
      try {
        currentPage = document.getElementsByClassName('customer-offer-match')[0]
          .getElementsByClassName('pagination')[0]
          .getElementsByClassName('active')[0]
          .getElementsByClassName('page-link')[0]
          .innerText.trim().replace( /\D+/g, '')
      } catch (e) {
          console.log(e)
      }
      
      this.getUserRequestMatches(currentPage)
    },
  }
};
</script>

<style lang="scss" scoped>
.modal {
  &__wrapper {
    // height: 25rem;
  }

  &__header {
    padding: 2.5rem 0.75rem 1.5rem;
  }

  &__body {
    max-height: 80vh;
    display: block;
    padding-bottom: 2rem;
    overflow: auto;
  }
}

.box {
  &_selectedAcc {
    width: 100%;
  }
}

.tbl {
  color: #ffffff;
}

.block_mt {
  margin-top: 20px;
}
.inner-modal__wrapper{
  position: fixed;
  top: -100%;
  left: -100%;
  right: -100%;
  bottom: -100%;
  background: rgba(0, 0, 0, 0.5);
  .modal__body{
    display: block;
  }

  .inner-modal{
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #272E35;
    max-width: 100%;
    width: 520px;
    .ttl, .label{
      color: #fff
    }
    .row {
      width: 100%;
      display: flex;
      align-items: center;
      padding: .25rem 0;
      margin: .25rem 0 0;
      flex-wrap: wrap;

      .label {
        width: 100%;
        padding-right: .75rem;
        font-weight: bold;
      }

      .data {
        flex-grow: 1;
        width: 100%;

        .inpt {
          width: 100%;
          color: #fff;

          &__ta {
            height: 7rem;
          }
        }
      }

      &__price {
        .data {
          display: flex;

          input {
            margin-right: .75rem;
          }

          select {
            color: white;
            background-color: var(--c_more-black);
            padding: .25rem .5rem;
            border-radius: 6px;
          }
        }
      }
    }
    .row{
      &_files {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 8px;

        .box_addFiles {
          width: 30%;
          //width: calc(50% - .75rem);
          //margin: .75rem 0;
          //padding: 1rem 1.75rem;
          //background: #22252B;
          box-shadow: 0px 12px 23px rgba(62, 73, 84, 0.04);
          display: flex;
          flex-direction: column;

          .ttl {
            padding-bottom: .25rem;
          }

          .separ {
            width: 3rem;
            height: .25rem;
            background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
            box-shadow: 0px 12px 23px rgba(62, 73, 84, 0.04);
            border-radius: 14px;
            margin: .25rem 0;
          }

          .content {
            padding: 1rem;
            flex-grow: 1;
            //margin-top: 1rem;
            border: 1px dashed #1763fb;
            box-sizing: border-box;
            filter: drop-shadow(0px 12px 23px rgba(62, 73, 84, 0.04));
            border-radius: 14px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;

            .choose {
              text-align: center;

              .btn {
                padding: 0.5rem;
                background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
                border-radius: 6px;
                color: #fff;
                font-size: 13px;
              }

              .desc {
                font-size: 12px;
                color: rgba(255, 255, 255, 0.3);
              }
            }

            &_many {
              flex-wrap: wrap;
              align-items: flex-start;
              justify-content: space-between;
              padding: 0.75rem 6px;

              .draggable {
                display: flex;
                padding: 0;
                flex-wrap: wrap;
              }

              .file {
                position: relative;
                text-align: center;
                width: 4.5rem;
                max-width: 4.5rem;

                svg.img {
                  width: 3rem;
                  height: 3rem;
                  margin: 0 auto;
                  cursor: pointer;
                  fill: #1763fb;
                  path{
                    fill: #1763fb;
                  }
                }
                .btn {
                  &_del {
                    position: absolute;
                    top: 0;
                    right: 1rem;
                    width: 1.25rem;
                    height: 1.25rem;
                    border-radius: 50%;
                    background-color: #B03636;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    svg.img {
                      width: 40%;
                      height: 40%;
                    }
                  }

                  &_download {
                    position: absolute;
                    top: 1.7rem;
                    right: 1rem;
                    width: 1.25rem;
                    height: 1.25rem;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    svg.img {
                      width: 90%;
                      height: 90%;
                    }
                  }
                }

                .desc {
                  font-size: 10px;
                  color: #fff;
                  word-break: break-word;
                }
              }

              .add {
                text-align: center;
                width: 2.5rem;
                max-width: 2.5rem;

                .btn {
                  width: 2.5rem;
                  height: 2.5rem;
                  border-radius: 50%;
                  background: linear-gradient(270deg, #1763fb 0%, #1763fb 100%), #1763fb;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  svg.img {
                    width: 45%;
                    height: 45%;
                    transform: rotate(45deg);
                  }
                }

                .desc {
                  font-size: 12px;
                  color: rgba(255, 255, 255, 0.3);
                }
              }
            }
          }
        }
      }
    }
  }
}
.check-item{
  &-row{
    display: flex;
    max-width: 100%;
    width: 100%;
    gap: 12px;
  }
  &-col{
    flex: 0 0 auto;
    max-width: 100%;
  }
  &-label{
    font-size: 16px;
    color: #000;
  }
}
.modal__wrapper{
  max-width: 95%;
}
</style>
